export const IS_MAC = typeof navigator !== "undefined" && /Mac|iPhone|iPad|iPod/i.test(navigator.platform || navigator.userAgent);
export const SEARCH_SHORTCUT = IS_MAC ? "⌘K" : "Ctrl K";
